import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useCallback, useState } from 'react';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { useCopyToClipboard } from 'src/utils/hooks';

export const CopyTextModal = () => {
  const { closeModal } = useModalMethods(Modals.CopyText);
  const { modalProps } = useModalState(Modals.CopyText);
  const { copyToClipboard } = useCopyToClipboard();

  const { text = '', title = 'Copy Text', onSuccess } = modalProps || {};
  const [value, setValue] = useState(text);

  const handleCopy = useCallback(async () => {
    try {
      await copyToClipboard(value);
      onSuccess?.();
    } catch (err) {
      console.error('Clipboard copy failed', err);
    }
    closeModal();
  }, [closeModal, copyToClipboard, value, onSuccess]);

  return (
    <Dialog open onClose={closeModal} fullWidth>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderColor: (theme) => theme.palette.custom.OV.sys.outlineVariant,
          px: 3,
        }}
      >
        <Typography>{title}</Typography>
      </DialogTitle>

      <DialogContent sx={{ py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <TextField
            autoFocus
            fullWidth
            size="small"
            variant="outlined"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            InputProps={{
              readOnly: true,
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2,
        }}
      >
        <Button variant="contained" onClick={handleCopy} disabled={!value}>
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};
